import { AppTheme } from '../types';
import { defaultTheme, themeClasses, animations } from '../mocks/theme';

export interface IThemeService {
  getTheme(): Promise<AppTheme>;
  getThemeClasses(): typeof themeClasses;
  getAnimations(): typeof animations;
  updateTheme(theme: Partial<AppTheme>): Promise<AppTheme>;
  resetTheme(): Promise<void>;
}

export class ThemeService implements IThemeService {
  private static instance: ThemeService;
  private currentTheme: AppTheme;

  public static getInstance(): ThemeService {
    if (!ThemeService.instance) {
      ThemeService.instance = new ThemeService();
    }
    return ThemeService.instance;
  }

  private constructor() {
    this.currentTheme = { ...defaultTheme };
  }

  async getTheme(): Promise<AppTheme> {
    // Simula carregamento de tema (poderia vir de localStorage, API, etc.)
    await this.delay(50);
    return { ...this.currentTheme };
  }

  getThemeClasses(): typeof themeClasses {
    return themeClasses;
  }

  getAnimations(): typeof animations {
    return animations;
  }

  async updateTheme(themeUpdates: Partial<AppTheme>): Promise<AppTheme> {
    this.currentTheme = {
      ...this.currentTheme,
      ...themeUpdates,
      colors: {
        ...this.currentTheme.colors,
        ...themeUpdates.colors,
        text: {
          ...this.currentTheme.colors.text,
          ...themeUpdates.colors?.text
        }
      }
    };
    
    await this.delay(100);
    return { ...this.currentTheme };
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public async resetTheme(): Promise<void> {
    this.currentTheme = { ...defaultTheme };
    await this.delay(100);
  }
}

export const createThemeService = (): IThemeService => {
  return ThemeService.getInstance();
};